frappe.ui.form.ControlDatetime = class ControlDatetime extends frappe.ui.form.ControlDate {
	set_formatted_input(value) {
		if (this.timepicker_only) return;
		if (!this.datepicker) return;
		if (!value) {
			this.datepicker.clear();
			// Reset the calendar view to "now" so a re-opened picker doesn't keep
			// showing the previously-selected month (upstream #40970).
			this.datepicker.date = this.get_now_date();
			return;
		} else if (value.toLowerCase() === "today") {
			value = this.get_now_date();
		} else if (value.toLowerCase() === "now") {
			value = frappe.datetime.now_datetime();
		}

		// show the value in the user's format/timezone
		const user_value = this.format_for_input(value);
		this.$input && this.$input.val(user_value);

		// @dokos: keep the datepicker's internal selection in sync with the actual value.
		// The control (and its datepicker) is reused across documents, so a stale
		// selection from a previously-opened doc can otherwise persist even though
		// the input text is correct (e.g. calendar slot -> Back -> new slot). Compare
		// against the value in the *user* timezone (user_to_obj(user_value)); the raw
		// system `value` would be mis-converted. See fix(datetime): sync datepicker
		// selection with field value (bd357fbf43).
		const date_obj = frappe.datetime.user_to_obj(user_value);
		let should_refresh = false;
		if (this.datepicker.selectedDates.length > 0) {
			const selected_date = this.datepicker.selectedDates[0];
			should_refresh = Math.abs(selected_date - date_obj) > 0;
		} else {
			should_refresh = true;
		}

		if (should_refresh) {
			// @dokos: guard the programmatic selectDate so onSelect doesn't fire a
			// spurious "change" event (it would dirty the form and re-run handlers).
			this._suppress_change = true;
			this.datepicker.selectDate(date_obj);
			this._suppress_change = false;
		}
	}

	get_start_date() {
		this.value = this.value == null || this.value == "" ? undefined : this.value;
		let value = frappe.datetime.convert_to_user_tz(this.value);
		return frappe.datetime.str_to_obj(value);
	}
	set_date_options() {
		super.set_date_options();
		this.today_text = __("Now");
		const sysdefaults = frappe.boot.sysdefaults;
		this.date_format = frappe.defaultDatetimeFormat;
		const time_format =
			sysdefaults && sysdefaults.time_format ? sysdefaults.time_format : "HH:mm:ss";
		$.extend(this.datepicker_options, {
			timepicker: true,
			timeFormat: time_format.toLowerCase().replace("mm", "ii"),
		});
	}

	get_now_date() {
		return frappe.datetime.now_datetime(true);
	}

	/** @param {string | null} value */
	parse(value) {
		let parsed = typeof value === "string" ? value.trim() : "";

		if (["today", "now"].includes(parsed.toLowerCase())) {
			parsed = frappe.datetime.now_datetime(false);
		} else if (parsed) {
			parsed = frappe.datetime.user_to_str(parsed, false);
			parsed = frappe.datetime.convert_to_system_tz(parsed, true);
		}

		if (parsed === "Invalid date") {
			console.warn("Invalid datetime", value); // eslint-disable-line
			parsed = "";
		}

		return parsed;
	}

	format_for_input(value) {
		if (!value) return "";

		return frappe.datetime.str_to_user(value, false);
	}

	set_description() {
		const description = this.df.description;
		const time_zone = this.get_user_time_zone();

		if (!this.df.hide_timezone) {
			// Always show the timezone when rendering the Datetime field since the datetime value will
			// always be in system_time_zone rather then local time.
			if (!description) {
				this.df.description = time_zone;
			} else if (!description.includes(time_zone)) {
				this.df.description += "<br>" + time_zone;
			}
		}
		super.set_description();
	}

	get_user_time_zone() {
		return frappe.boot.time_zone ? frappe.boot.time_zone.user : frappe.sys_defaults.time_zone;
	}

	set_datepicker() {
		super.set_datepicker();
		if (this.datepicker.opts.timeFormat.indexOf("s") == -1) {
			// No seconds in time format
			const $tp = this.datepicker.timepicker;
			$tp.$seconds.parent().css("display", "none");
			$tp.$secondsText.css("display", "none");
			$tp.$secondsText.prev().css("display", "none");
		}
	}

	get_model_value() {
		let value = super.get_model_value();
		if (!value && !this.doc) {
			value = this.last_value;
		}

		return !value ? "" : frappe.datetime.get_datetime_as_string(value);
	}
};
